import React from 'react'
import { RetentionRule } from '../../../models/RetentionPolicy'

export const RetentionPolicyZeroRuleBody: React.FC<{ retentionRule: RetentionRule }> = () => {
  return (
    <>
      <div>
        <div>Rule</div>
        <div aria-label='Rule'>Deleted as soon as processing completes.</div>
      </div>
    </>
  )
}
